import getOwnerWindow from './getOwnerWindow';
import getOwnerDocument from './getOwnerDocument';
/**
 * Determines whether the specified element is partially within the
 * viewport.
 */

export default function isElementPartiallyInViewport(element) {
  var rect = element.getBoundingClientRect();
  var window = getOwnerWindow(element);
  var document = getOwnerDocument(element);
  var windowHeight = window != null && window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window != null && window.innerWidth || document.documentElement.clientWidth;
  var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  var horzInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horzInView;
}
//# sourceMappingURL=isElementPartiallyInViewport.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/isElementPartiallyInViewport.js
// module id = 521
// module chunks = 0 1